import { css } from 'lit';

export default css`
  .preview {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: calc(240px * var(--private-scale));
    height: calc(430px * var(--private-scale));
    padding: 0 10px;
    border-radius: 20px;
  }

  .preview--video {
    padding: 0;
  }

  amityeko-chip::part(base) {
    padding: 4px 12px 4px 4px;
    --amityeko-color-gray-9: rgba(66, 66, 66, 0.8);
    --amityeko-color-gray-1: var(--amityeko-color-font-light);
    --amityeko-color-gray-8: rgba(66, 66, 66, 0.9);
  }

  .preview__chip {
    height: calc(40px * var(--private-scale));
    position: absolute;
    right: 10px;
    top: 10px;
    z-index: 103;
  }

  .preview__chip__image {
    width: calc(32px * var(--private-scale));
    height: calc(32px * var(--private-scale));
    object-fit: cover;
    border-radius: 50%;
  }

  .preview__backgroundGradient {
    position: absolute;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      197.39deg,
      var(--private-bg-color-one, #3ddbd9) 0%,
      var(--private-bg-color-two, #0072c3) 100%
    );
    z-index: 100;
    border-radius: 20px;
  }

  .preview__backgroundImage {
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 100;
    border-radius: 20px;
  }

  .preview__animation {
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 101;
    border-radius: 20px;

    /* It is a minor hack that removes the scroll that appears when the animation url is broken. */
    line-height: 0;
  }

  .preview__content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    z-index: 102;
  }

  .preview__content amityeko-tg-label-one {
    color: var(--private-text-color);
    text-align: center;
    word-break: break-all;
  }

  .preview__content__gif {
    width: calc(100px * var(--private-scale));
    height: calc(100px * var(--private-scale));
  }

  rnr-image-layout-content {
    width: 140px;
    height: 140px;
    display: var(--private-image-layout-display);
  }

  rnr-video {
    width: 100%;
    height: 100%;
  }
`;
